import {Component} from '@angular/core';
import {AuthService} from '../shared/services/auth.service';

@Component({
    selector: 'wm-reset-password',
    styleUrls: ['./reset-password.component.less'],
    templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent {

    email: string = '';

    requestFinished: boolean = false;
    requesting: boolean = false;
    error: boolean = false;

    constructor(private authService: AuthService) {
    }

    submitResetPassword() {
        let emailAddress = this.email;
        this.requesting = true;
        this.authService.requestResetPassword(emailAddress, this.resetLinkForPassword()).subscribe(
            result => {
                this.requestFinished = true;
                this.requesting = false;
            },
            err => {
                this.error = true;
                this.requesting = false;
            }
        );
    }

    private resetLinkForPassword(): string {
        let currentURL = window.location.href;
        return currentURL.substring(0, currentURL.indexOf('resetpassword')) + 'confirmreset';
    }

}
